import { render } from "./ServerDeleteConfirm.vue?vue&type=template&id=d806d7be&scoped=true"
import script from "./ServerDeleteConfirm.vue?vue&type=script&lang=js"
export * from "./ServerDeleteConfirm.vue?vue&type=script&lang=js"

import "./ServerDeleteConfirm.vue?vue&type=style&index=0&id=d806d7be&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d806d7be"],['__file',"src/assets/js/pages/Popup/ServerDeleteConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d806d7be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d806d7be', __exports__)) {
    api.reload('d806d7be', __exports__)
  }
  
  module.hot.accept("./ServerDeleteConfirm.vue?vue&type=template&id=d806d7be&scoped=true", () => {
    api.rerender('d806d7be', render)
  })

}


export default __exports__